export default "__VITE_ASSET__Dq5_PeaQ__"